function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import * as React from "react";
import { useId } from "@react-aria/utils";
import ChevronDown from "@bolteu/kalep-react-icons/dist/ChevronDown";
import { ListItemLayout } from "../ListItemLayout";
import { cx } from "../../helpers/utils/cx";
import { AccordionActionType } from "./Accordion.types";
function reducer(state, action) {
  switch (action.type) {
    case AccordionActionType.OPEN:
      return _objectSpread(_objectSpread({}, state), {}, {
        expandedKeys: new Map(state.expandedKeys).set(action.id, true)
      });
    case AccordionActionType.CLOSE:
      return _objectSpread(_objectSpread({}, state), {}, {
        expandedKeys: new Map(state.expandedKeys).set(action.id, false)
      });
    default:
      throw new Error("Accordion reducer received an unknown action");
  }
}
const initialState = {
  expandedKeys: new Map(),
  disabledKeys: new Map(),
  showSeparator: true
};
const AccordionContext = /*#__PURE__*/React.createContext({
  state: initialState,
  dispatch: () => {}
});
export function Accordion(_ref) {
  let {
    children,
    expandedKeys,
    disabledKeys,
    onExpandedChange,
    paddingStart = 6,
    paddingEnd = 6,
    showSeparator = true
  } = _ref;
  const [state, dispatch] = React.useReducer(reducer, {
    expandedKeys: expandedKeys ? new Map(expandedKeys.map(key => [key, true])) : new Map(),
    disabledKeys: disabledKeys ? new Map(disabledKeys.map(key => [key, true])) : new Map(),
    showSeparator
  });
  React.useEffect(() => {
    const newExpandedKeys = [...state.expandedKeys].filter(_ref2 => {
      let [_k, v] = _ref2;
      return v;
    }).map(_ref3 => {
      let [k, _v] = _ref3;
      return k;
    });
    onExpandedChange?.(new Set(newExpandedKeys));
  }, [state.expandedKeys, onExpandedChange]);
  const outerContainerStyle = React.useMemo(() => {
    return {
      paddingLeft: getRemFromSpacingSize(paddingStart),
      paddingRight: getRemFromSpacingSize(paddingEnd)
    };
  }, [paddingStart, paddingEnd]);
  const contextValue = React.useMemo(() => ({
    state,
    dispatch
  }), [state, dispatch]);
  return /*#__PURE__*/React.createElement(AccordionContext.Provider, {
    value: contextValue
  }, /*#__PURE__*/React.createElement("ul", {
    className: cx("flex flex-col list-none p-0 m-0"),
    style: outerContainerStyle
  }, children));
}
export function AccordionItem(_ref4) {
  let {
    id,
    title,
    children
  } = _ref4;
  const {
    state,
    dispatch
  } = React.useContext(AccordionContext);
  const ref = React.useRef(null);
  const isOpen = state.expandedKeys.get(id);
  const isDisabled = state.disabledKeys.get(id);
  const generatedId = useId();
  const sectionId = `kalep-accordion-section-${generatedId}`;
  const buttonId = `kalep-accordion-button-${generatedId}`;
  const clickHandler = React.useCallback(() => {
    dispatch({
      id,
      type: isOpen ? AccordionActionType.CLOSE : AccordionActionType.OPEN
    });
  }, [isOpen, dispatch, id]);
  return /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    className: `flex flex-col ${state.showSeparator && "border-solid border-0 border-separator border-b"}`
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    id: buttonId,
    ref: ref,
    "data-testid": "kalep-accordion-expand-row-button",
    disabled: isDisabled,
    "aria-expanded": isOpen ? "true" : "false",
    "aria-controls": sectionId,
    onClick: clickHandler,
    className: cx( /* resets */"border-none select-none outline-offset-2 bg-special-nulled", "flex items-center justify-between relative text-left", "w-full flex-1 gap-x-3 p-0", "ease-linear duration-150", isDisabled ? "cursor-not-allowed" : "cursor-pointer")
  }, /*#__PURE__*/React.createElement(ListItemLayout, _extends({
    paddingStart: 0,
    paddingEnd: 0,
    disabled: isDisabled
  }, title)), /*#__PURE__*/React.createElement("div", {
    className: cx("shrink-0 w-6 h-6")
  }, /*#__PURE__*/React.createElement(AccordionArrow, {
    isOpen: isOpen
  }))), /*#__PURE__*/React.createElement("div", {
    role: "region",
    id: sectionId,
    "aria-labelledby": buttonId,
    className: cx("transition-all grid duration-300 ease-in-out", isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0")
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("overflow-hidden")
  }, /*#__PURE__*/React.createElement("div", {
    className: cx("ps-3 mt-2 mb-5")
  }, children)))));
}
export function AccordionArrow(_ref5) {
  let {
    isOpen
  } = _ref5;
  return /*#__PURE__*/React.createElement(ChevronDown, {
    size: "lg",
    "aria-hidden": "true",
    className: cx("absolute right-0 shrink-0 origin-center transition-transform text-tertiary", isOpen ? "rotate-180" : "rotate-0")
  });
}
function getRemFromSpacingSize(spacingValue) {
  return `${spacingValue / 4}rem`;
}